import { Action, ActionReducer, combineReducers } from '@ngrx/store';

import * as fromAssets from './assets.reducer';

export const featureKey = 'oyanAssets';

export interface AssetsState {
  [fromAssets.featureKey]: fromAssets.State;
}

export interface State {
  [featureKey]: AssetsState;
}

export function reducers(state: AssetsState, action: Action): ActionReducer<AssetsState> {
  return combineReducers({
    [fromAssets.featureKey]: fromAssets.reducer
  })(state, action) as unknown as ActionReducer<AssetsState>;
}
